import { composeFetch } from '@library/http'
import { getAuthUserId } from '@library/auth'
import {
  composeRequest,
  addPath,
  setServiceUrl,
  setMethod,
  setQueryParams,
  goustoHeaders,
} from '@library/http/requests'
import { Menu } from './types'

export type MenuRequestParams = {
  date?: string
  deliveryDate?: string
  numPortions: number
  // admin link data
  'preview[menu_id]'?: string
  'preview[auth_user_id]'?: string
  'preview[expiry]'?: string
  'preview[signature]'?: string
}

const menuApiMenuParse = async (response: Response): Promise<Menu> => {
  const body = await response.text()
  const parsedBody = JSON.parse(body)

  if (!response.ok) {
    throw new Error(parsedBody.message)
  }

  return parsedBody as Menu
}

const menuApiMenuRequest = composeRequest(
  setServiceUrl('menu', 3),
  addPath((params: MenuRequestParams | undefined) => {
    // if it is admin query
    if (params && params['preview[auth_user_id]']) {
      return `menus/${params['preview[menu_id]']}/preview`
    }

    return 'menus'
  }),
  goustoHeaders,
  setQueryParams(({ date, deliveryDate, numPortions, ...rest }: MenuRequestParams) => {
    const isAdminQuery = rest && rest['preview[auth_user_id]']

    const userId = isAdminQuery ? rest['preview[auth_user_id]'] : getAuthUserId()

    return {
      include_core_recipe_id: 'true',
      include_core_menu_id: 'true',
      ...(date && { date }),
      ...(deliveryDate && { delivery_date: deliveryDate }),
      num_portions: numPortions.toString(),
      ...(userId && { user_id: userId }),
      ...(isAdminQuery && {
        signature: rest['preview[signature]'],
        expiry: rest['preview[expiry]'],
      }),
    }
  }),
  setMethod('GET'),
)

export const menuFetcher = composeFetch(menuApiMenuRequest, menuApiMenuParse)
